import React from 'react'
import GaugeChart from './gaugeChart'

export default function SolarGenerationGauge({ 
  id,
  value,
  min,
  max,
  expectedLow,
  expectedHigh,
  label
}: {
  id: string,
  value: number;
  min: number;
  max: number;
  expectedLow: number;
  expectedHigh: number;
  label: string;
}) {
  return (
    <GaugeChart
      id={id} 
      value={value}
      min={min}
      max={max}
      expectedLow={expectedLow}
      expectedHigh={expectedHigh}
      label={label}
    />
  )
}